import rawRequest from "../rawRequest";
import { useQuery } from "@tanstack/react-query";

const refetchIntervalSeconds = 120; // decide how often to refetch the data per second

// fetch the ETL status
export const useETLData = (environment) =>
	useQuery({
		queryKey: ["etl-status", environment],
		queryFn: () => rawRequest({ url: `/${environment}/etl-status`, method: "GET" }),
		refetchInterval: 1000 * refetchIntervalSeconds,
		retry: 5,
	});

// fetch the reporting data
export const useReviewReportingData = (environment, searchID) =>
	useQuery({
		queryKey: ["review-reporting-by-id", environment],
		queryFn: () => rawRequest({ url: `/${environment}/reporting/${searchID}`, method: "GET" }),
		enabled: false,
		retry: 0,
		initialData: {},
	});
